import type { RootState, UserState } from '../types';
import { getAuthTeamId } from './auth';
import { getProfileState, isProfileLoaded } from './profile';

export interface UserDomainState {
    profile: UserState['profile'];
    teamId: number | null;
    isLoaded: boolean;
    isLoading: boolean;
}

export function getUserState(state: RootState): UserState {
    return state.user;
}

export function getUserDomain(state: RootState): UserDomainState {
    const user = getUserState(state);
    const profile = getProfileState(state);

    return {
        profile,
        teamId: getUserTeamId(state),
        isLoaded: isProfileLoaded(state),
        isLoading: !user.initialized || Boolean(user.pending)
    };
}

export function getUserProfile(state: RootState) {
    return getProfileState(state);
}

export function getUserTeamId(state: RootState) {
    return getAuthTeamId(state) ?? null;
}

export function isUserLoaded(state: RootState): boolean {
    return isProfileLoaded(state);
}

export function isUserLoading(state: RootState): boolean {
    const user = getUserState(state);
    return !user.initialized || Boolean(user.pending);
}

export function getUserScores(state: RootState) {
    return state.user.userScore;
}

export function getUserScoresError(state: RootState) {
    return state.user.userScoreError;
}
